import request from './request';
import URLS from '../configurations/urls';
import Api from './Api';

class SettlementsApi extends Api{

    static getSettlementRequests(params){
        let options =  Object.assign({}, Api.HTTP_OPTIONS);
        options.url += `${URLS.ARBITER_API_SETTLEMENT_REQUESTS}`;
        options.params = params;
        return request.get(options);
    }

    static getSettlementRequestStatuses(params){
        let options =  Object.assign({}, Api.HTTP_OPTIONS);
        options.url += `${URLS.ARBITER_API_SETTLEMENT_REQUEST_STATUSES}`;
        options.params = params;
        return request.get(options);
    }

    static processSettlementRequest(requestReference, data){
        let options =  Object.assign({}, Api.HTTP_OPTIONS);
        options.url += `${URLS.ARBITER_API_SETTLEMENT_REQUESTS}/${requestReference}`;
        options.data = data;
        return request.post(options);
    }

    static mapSettlementRequestParticipants(requestReference){
        let options =  Object.assign({}, Api.HTTP_OPTIONS);
        options.url += `${URLS.ARBITER_API_SETTLEMENT_REQUESTS}/${requestReference}/participants`;
        options.data = {};
        return request.post(options);
    }
}

export default SettlementsApi;



// WEBPACK FOOTER //
// ./src/api/SettlementsApi.js